import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector:'app-poshvine-chip',
    templateUrl:'./chips.component.html',
    styleUrls:['./chips.component.scss']
})
export class ChipComponent{
    @Input() labelText = '';
    @Input() type:'primary'|'secondary' = 'primary';
    @Output() removeEvent:EventEmitter<any> = new EventEmitter<any>();
    constructor(){

    }
    triggerRemoveEvent(){
        this.removeEvent.emit('remove');
    }
}